import Component from '@glimmer/component';
import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';
import { TrackedAsyncData } from 'ember-async-data';
import Header from './header';
import noop from '../../../helpers/noop';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import t from 'ember-intl/helpers/t';
import repeat from '../../../helpers/repeat';
import truncate from '../../../helpers/truncate';
import random from 'ember-math-helpers/helpers/random';
import { faBuildingColumns, faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';

export default class ReportsCurriculumLoadingComponent extends Component {
  @service router;
  @service intl;
  @service store;
  @service currentUser;

  userModel = new TrackedAsyncData(this.currentUser.getModel());

  @cached
  get user() {
    return this.userModel.isResolved ? this.userModel.value : null;
  }

  @cached
  get allSchools() {
    return this.store.peekAll('school');
  }

  get primarySchool() {
    return this.allSchools.find(({ id }) => id === this.user?.belongsTo('school').id());
  }

  get queryParams() {
    return this.router.currentRoute.queryParams;
  }

  get guessCourses() {
    return this.queryParams?.courses?.split('-').length;
  }

  get selectedReportValue() {
    return this.queryParams?.report ?? null;
  }
  <template>
    <div
      class="reports-curriculum reports-curriculum-loading loading-shimmer loading-text main-section"
      data-test-reports-curriculum
      ...attributes
    >
      <Header
        @countSelectedCourses={{this.guessCourses}}
        @showReportResults={{false}}
        @loading={{false}}
        @selectedReportValue={{this.selectedReportValue}}
        @changeSelectedReport={{(noop)}}
        @runReport={{(noop)}}
        @close={{(noop)}}
      />
      <div class="reports-choose-course">
        <div class="schools">
          <FaIcon @icon={{faBuildingColumns}} />
          <select aria-label={{t "general.filterBySchool"}} class="loading-text" disabled>
            <option>{{this.primarySchool.title}}</option>
          </select>
        </div>
        <ul class="year">
          <li>
            <button type="button">
              {{2025}}
              <FaIcon @icon={{faCaretRight}} />
            </button>
          </li>
          <li>
            <button type="button">
              {{2024}}
              <FaIcon @icon={{faCaretDown}} />
            </button>
            <ul class="courses">
              {{! template-lint-disable no-unused-block-params }}
              {{#each (repeat 5)}}
                <li>
                  <label>
                    <input type="checkbox" disabled />
                    {{truncate (repeat (random 3 10) "ilios rocks") 100}}
                  </label>
                </li>
              {{/each}}
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </template>
}
